import { useMutation, useQuery } from 'react-query';
import queryGetSubscriptions from './queries/getSubscriptions';
import mutationTerminateSubscription from './mutations/terminateSubscription';
import mutationScheduledTerminateSubscription from './mutations/scheduledTerminateSubscription';
import mutationActivateSubscription from './mutations/activateSubscription';
import mutationMigrateSubscription from './mutations/migrateSubscription';
import queryGetSubscription from './queries/getSubscription';
import queryGetPosTerminalStatusInfo from './queries/getPosTerminalStatusInfo';
import mutationUpdateSubscription from './mutations/updateSubscription';
import mutationAddEnvelope from './mutations/addEnvelope';

const actionsSubscriptions = {
    // Getters
    // Get subscription
    getSubscription: (subscriptionId) => useQuery(queryGetSubscription(subscriptionId)),
    // Get subscriptions
    getSubscriptions: (query, enabled = true) => useQuery(queryGetSubscriptions(query, enabled)),
    // Get POS Terminal status info
    getPosTerminalStatusInfo: (subscriptionId) => useQuery(queryGetPosTerminalStatusInfo(subscriptionId)),

    // Mutations
    // Activate subscription
    activateSubscription: (onSuccess, onError) => useMutation(mutationActivateSubscription(onSuccess, onError)),
    // Update subscription
    updateSubscription: (onSuccess, onError) => useMutation(mutationUpdateSubscription(onSuccess, onError)),
    // Terminate subscription
    terminateSubscription: (onSuccess, onError) => useMutation(mutationTerminateSubscription(onSuccess, onError)),
    scheduledTerminateSubscription: (onSuccess, onError) => useMutation(mutationScheduledTerminateSubscription(onSuccess, onError)),
    // Migrate sbscription
    migrateSubscription: (onSuccess, onError) => useMutation(mutationMigrateSubscription(onSuccess, onError)),
    // Add Enveope
    addEnvelope: (onSuccess, onError) => useMutation(mutationAddEnvelope(onSuccess, onError))
};

export default actionsSubscriptions;